import React from 'react';
import {Link} from 'react-router-dom';
import { assetPath, company } from '../../data/companyData';

export default class LogoBox extends React.Component {
    render(){
        return (
            <>
                <div className="logo-box">
                    <Link to={process.env.PUBLIC_URL + `/`}>
                        <img src={assetPath("logo-fa-interior-trim.png")} alt={company.name} style={{maxHeight: "78px", width: "auto"}} />
                    </Link>
                </div>
            </>
        )
    }
}
